/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most administrative and data-entry roles ask for 60-75 WPM sustained over a few minutes, not a 1-minute burst. Customer support and general office roles are often more lenient, around 40-50 WPM. Check the specific job posting — required speed varies more by role than by industry.`)
};

const es_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mayoría de los puestos administrativos y de captura de datos piden 60-75 WPM sostenidos durante varios minutos, no un arranque de 1 minuto. Los puestos de atención al cliente y de oficina general suelen ser más flexibles, alrededor de 40-50 WPM. Revisa la oferta de trabajo específica — la velocidad requerida varía más según el puesto que según la industria.`)
};

const de_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meisten Verwaltungs- und Dateneingabe-Rollen verlangen 60-75 WPM über mehrere Minuten hinweg, nicht nur einen 1-Minuten-Ausbruch. Kundensupport- und allgemeine Bürorollen sind oft nachsichtiger, bei etwa 40-50 WPM. Prüfe die konkrete Stellenausschreibung — die geforderte Geschwindigkeit variiert stärker nach Rolle als nach Branche.`)
};

const nl_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meeste administratieve en data-invoerfuncties vragen om 60-75 WPM volgehouden over enkele minuten, niet een sprint van 1 minuut. Klantenservice- en algemene kantoorfuncties zijn vaak soepeler, rond de 40-50 WPM. Controleer de specifieke vacature — de vereiste snelheid verschilt meer per functie dan per branche.`)
};

const fr_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plupart des postes administratifs et de saisie de données demandent 60 à 75 WPM soutenus sur plusieurs minutes, pas un pic d'1 minute. Le support client et les postes de bureau généraux sont souvent plus souples, autour de 40 à 50 WPM. Vérifiez l'offre d'emploi spécifique — la vitesse requise varie plus selon le poste que selon le secteur.`)
};

const it_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La maggior parte dei ruoli amministrativi e di data entry richiede 60-75 WPM sostenuti per qualche minuto, non uno scatto da 1 minuto. I ruoli di assistenza clienti e da ufficio generico sono spesso più flessibili, intorno ai 40-50 WPM. Controlla l'offerta di lavoro specifica — la velocità richiesta varia più in base al ruolo che al settore.`)
};

const pt_br2_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria das vagas administrativas e de entrada de dados pede 60-75 WPM sustentados ao longo de alguns minutos, não uma explosão de 1 minuto. Vagas de suporte ao cliente e escritório em geral costumam ser mais flexíveis, em torno de 40-50 WPM. Confira a vaga específica — a velocidade exigida varia mais por função do que por setor.`)
};

const pt_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria das funções administrativas e de introdução de dados pede 60-75 WPM sustentados ao longo de alguns minutos, não um pico de 1 minuto. As funções de apoio ao cliente e de escritório em geral são muitas vezes mais flexíveis, à volta de 40-50 WPM. Verifique a oferta de emprego específica — a velocidade exigida varia mais consoante a função do que consoante o setor.`)
};

const ja_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事務職やデータ入力職の多くは、1分間だけの瞬発力ではなく、数分間持続する60〜75WPMを求めています。カスタマーサポートや一般的なオフィス職はもう少し緩やかで、40〜50WPM程度であることが多いです。必要な速度は業界よりも職種によって大きく異なるため、応募先の求人票を確認してください。`)
};

const zh_typing_u3_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大多数行政和数据录入岗位要求在几分钟内持续保持60-75 WPM，而非1分钟的爆发速度。客服和一般行政岗位的要求通常更宽松，约为40-50 WPM。请查看具体招聘信息 — 所需速度因岗位而异，差异往往大于因行业而异。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u3_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u3_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u3_faq4_a", locale)
	if (locale === "en") return en_typing_u3_faq4_a(inputs)
	if (locale === "es") return es_typing_u3_faq4_a(inputs)
	if (locale === "de") return de_typing_u3_faq4_a(inputs)
	if (locale === "nl") return nl_typing_u3_faq4_a(inputs)
	if (locale === "fr") return fr_typing_u3_faq4_a(inputs)
	if (locale === "it") return it_typing_u3_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u3_faq4_a(inputs)
	if (locale === "pt") return pt_typing_u3_faq4_a(inputs)
	if (locale === "ja") return ja_typing_u3_faq4_a(inputs)
	return zh_typing_u3_faq4_a(inputs)
};